module.exports = __webpack_public_path__ + "static/img/favicon.17b34a5b.png";